import React from 'react'
import Header from '../component/Header/Header'
import TeamCards from '../component/TeamCards/TeamCards'
import HomeProgram from '../component/HomeProgram/HomeProgram'
import TeamInnerHero from '../component/TeamInnerHero/TeamInnerHero'
import Footer from '../component/Footer/Footer'
import TeamLdCare from '../component/TeamLdCare/TeamLdCare'

function TeamIndividual() {


    const cardList = [
  {
    link:`/team-individual/${1}`,
    img:"/images/team/1.png",
    name:"Dr. Fabio Varlese (Founder)",
    rank:"MD, MSc, FRCPC",
    para:'Dr. Fabio Varlese is a prominent Specialist in Internal Medicine and Geriatric Medicine. He graduated Summa Cum Laude at the University of Rome, later becoming a diplomat with the American Board of Internal Medicine specializing in Internal Medicine at the Cleveland Clinic Health System.'
  },
  {
    link:`/team-individual/${2}`,
    img:"/images/team/2.png",
    name:"Dr. Giuseppe Papia",
    rank:"MD, MSc, FRCSC",
    para:'Dr. Giuseppe Papia is a member of the Division of Cardiac and Vascular Surgery and the Division of Critical Care Medicine at Sunnybrook Health Sciences Centre since 2008.'
  },
  {
    link:`/team-individual/${3}`,
    img:"/images/team/3.png",
    name:"Dr. Diego Delgado",
    rank:"MD, MSc, FRCPC",
    para:'Dr. Diego Delgado graduated in Medicine from the Universidad del Salvador in Buenos Aires, Argentina, and completed Internal Medicine and Cardiology training at Hospital Español in Buenos Aires.'
  },
  {
    link:`/team-individual/${4}`,
    img:"/images/team/4.png",
    name:"Dr. Marcus Bernardini",
    rank:"MD, MSc, FRCSC",
    para:'Dr. Marcus Bernardini is Head of the Division of Gynecologic Oncology at the University Health Network and Sinai Health System. '
  },
  // {
  //   link:`/team-individual/${5}`,
  //   img:"/images/team/5.png",
  //   name:"Dr. Karim Ladha",
  //   rank:"MD, MSc, FRCPC",
  //   para:'Dr. Karim Ladha is the Evelyn Bateman Recipe Chair in Ambulatory Anesthesia and Women’s Health at Women’s College Hospital and an Associate Professor at the University of Toronto.'
  // },
  {
    link:`/team-individual/${6}`,
    img:"/images/team/6.png",
    name:"Dr. Giuseppe Costa",
    rank:"MD, FRCSC",
    para:'Dr. Giuseppe Costa is an orthopaedic surgeon specializing in sports/arthroscopy/upper extremity reconstruction and lower extremity reconstruction. '
  },
]

  return (
    <div style={{backgroundColor:"#FAF6ED"}}>
        <Header/>
        
       <div style={{backgroundImage:"url(/images/creatives/gradient-bg-3.png)",backgroundPosition:"bottom",backgroundSize:"contain",backgroundRepeat:"no-repeat"}}>
        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
            <TeamInnerHero/>
        </div>
        <div className='py-4'></div>
            <TeamLdCare
                heading='Team'
                spanHeading="- led excelence"
                paragraph="For over 15 years, The Toronto Clinic has been at the forefront of leveraging Multidisciplinary Clinical teams to deliver the highest quality of care to patients."
                showBtn={true}
                // cardData={cardList}
                noSwiper={false}
                noLearnMoreAnchor={true}
                imgBg={true}
                customBtnText='Meet The Team'
                cusBlueBtnRef={"/team"}
            /> 
        </div>

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"center",backgroundSize:"contain",backgroundRepeat:"no-repeat"}}>
            <HomeProgram
            mainCardHeading="The path to health begins here, take the first step"
            mainCardPara="At The Toronto Clinic, we redefine healthcare with a proactive, deeply personalized approach. Designed to support your longevity and well-being, our program ensures you stay at your peak: healthy, confident, and in control."
            btnText="Explore membership"
            btnRef="/membership"
            mainCardImg={"/images/creatives/membership-text-2.png"}
            showList={false}
            leftBottomBorderRadius={true}
            backgroundPlain={true}
            />
            <Footer
            newsletterSection={false}
            />
        </div>
    </div>
  )
}

export default TeamIndividual